module.exports = __webpack_public_path__ + "static/media/icn_programme.e43dcd3b.svg";